(function () {
  'use strict';

  angular.module('app').component('clientProfileDetail', clientProfileDetail());

  function clientProfileDetail() {
    return {
      bindings: {
        item: '=',
        onClientProfileSaved: '&',
        onClientProfileCanceled: '&',
      },
      controller: ClientProfileDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/client-profiles/client-profile-detail/client-profile-detail.component.html',
    };
  }

  ClientProfileDetailComponent.$inject = [
    'UtilService',
    'ClientProfileService',
    'PriceListService',
  ];

  function ClientProfileDetailComponent(UtilService, ClientProfileService, PriceListService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.openPriceListsModal = openPriceListsModal;

    vm.onClientsAdded = onClientsAdded;
    vm.onClientsRemoved = onClientsRemoved;
    vm.onClientProfileSeasonsUpdated = onClientProfileSeasonsUpdated;

    vm.saveClientProfile = saveClientProfile;
    vm.cancel = cancel;

    vm.$onInit = function () {
      if (vm.item.id) {
        // Edit
        vm.flashMessage = vm.UtilService._displayFlashMessage();
        setItemOptions(vm.item);
      } else {
        // New
        vm.createMode = true;

        vm.item.client_ids = [];

        vm.associatedClients = [];
      }

      // Initializers
      getPriceLists();
    };

    function setItemOptions(item) {
      vm.editMode = true;

      setAssociatedClients(item.clients);

      vm.itemName = item.name;
    }

    function setAssociatedClients(clients) {
      vm.associatedClients = [];
      // To avoid removing associated clients for the profile
      for (var i = 0; i < clients.length; i++) {
        clients[i].disable = true;
        vm.associatedClients.push(clients[i]);
      }
    }

    function getPriceLists() {
      var params = {
        get: 'active',
        contact_type: 'client',
        skip_check_role: true,
      };

      PriceListService.getPriceLists(params).then(function (data) {
        vm.priceLists = data.items;
      });
    }

    function openPriceListsModal(option) {
      var successCallback = function () {
        getPriceLists();
      };

      PriceListService.openPriceListsModal(successCallback);
    }

    function onClientsAdded(clientIds) {
      vm.item.client_ids = clientIds;
    }

    function onClientsRemoved(clientIds) {
      vm.item.client_ids = clientIds;
    }

    function onClientProfileSeasonsUpdated() {
      //console.log('SEASONS UPDATED'); // what to do from here?
    }

    function saveClientProfile(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        vm.UtilService.scrollToTop();

        return;
      }

      var data = {
        id: vm.item.id,
        name: vm.item.name,
        company_id: vm.item.company_id,
        price_list_id: vm.item.price_list_id,
        client_ids: vm.item.client_ids,
      };

      // console.log(data); return;

      vm.sendingForm = true;
      ClientProfileService.saveClientProfile(data).then(function (data) {
        var status = data.status;
        var response = data.response;

        console.log(data);

        if (status) {
          // success
          if (!vm.editMode) {
            // create
            vm.onClientProfileSaved({ item: response });
          } else {
            vm.flashMessage = vm.UtilService._clearFlashMessage();

            setItemOptions(response);
          }
        } else {
          vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
          vm.formErrors = true;
        }

        vm.sendingForm = false;
        vm.UtilService.scrollToTop();
      });
    }

    function cancel() {
      vm.onClientProfileCanceled();
    }
  }
})();
